import React from 'react'
import { Link, useNavigate } from 'react-router-dom'

import PageHeading from '../../components/layout/PageHeading'
import { OuterTabGroup } from '../../components/form/tab-groups'
import { useI18N } from '../../../libraries/i18n/hook'
import TabSelectBox from '../../components/form/tab-groups/TabSelectBox'
import BloomLogo from '../../../assets/bloom-logo-custom-color.svg?react'
import PremiumTag from '../../components/premium/Tag'

export enum STUDIO_AI_TABS { ADVISOR_AI = 'advisor-ai', CV_ROASTER = 'cv-roaster', AI_INTERVIEW = 'ai-interview' }

type Props = {
  children: React.ReactNode | React.ReactNode[],
  buttons?: React.ReactNode | React.ReactNode[],
  activeTab: STUDIO_AI_TABS.ADVISOR_AI | STUDIO_AI_TABS.CV_ROASTER | STUDIO_AI_TABS.AI_INTERVIEW
  goBackLink?: string
}

const MasterStudioAIPage: React.FC<Props> = ({ children, buttons, activeTab, goBackLink = '/' }) => {
  const { t } = useI18N()
  const navigate = useNavigate()

  const handleTabClick = (tabId: string) => {
    navigate(`/${tabId}`, { replace: true })
  }

  const tabs = [
    { id: STUDIO_AI_TABS.ADVISOR_AI, title: 'Advisorᴬᴵ' },
    { id: STUDIO_AI_TABS.CV_ROASTER, title: t('cv.page.title'), isPremium: true },
    { id: STUDIO_AI_TABS.AI_INTERVIEW, title: 'Interviewer AI', isPremium: true },
  ]
  return (
    <div className='bg-white lg:m-3 lg:px-6 lg:py-2 rounded-lg min-h-screen'>
      <div className='w-full bg-gray-300 z-10 lg:bg-inherit sticky top-0 lg:relative p-2 lg:p-1 shadow-md lg:shadow-none inline-flex items-center sm:items-end justify-between lg:mb-6 lg:block'>
        <div>
          <PageHeading noMargin small goBackLink={goBackLink}>
            <div className='flex items-center gap-x-6'>
              <Link to='/'><BloomLogo className='fill-deep-green lg:pe-6 lg:border-r-2 border-deep-green border-solid logo h-7 w-auto' /></Link>
              <h1 className='text-dark-green hidden lg:block leading-none'>Studioᴬᴵ</h1>
              <div className='block lg:hidden '>
                <TabSelectBox
                  options={tabs.map(tab => ({ label: tab.title, value: tab.id, tag: tab.isPremium ? <div><PremiumTag size='sm' hideLabel /></div>: <div className='w-5' /> }))}
                  onChange={handleTabClick}
                  value={activeTab}
                />
              </div>
            </div>
          </PageHeading>
        </div>
        <div className='flex flex-row items-end lg:hidden'>
          {buttons}
        </div>
      </div>
      <div className='hidden lg:block bg-white'>
        <OuterTabGroup
          tabs={tabs}
          handleClick={handleTabClick}
          active={activeTab}
        />
      </div>
      <div className='px-1'>
        {children}
      </div>
    </div>
  )
}

export default MasterStudioAIPage
